// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__-dLaf","title":"Header_title__7dQtL","side":"Header_side__3tAmu"};